
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Form, Input, Radio, Select } from 'antd';
import toast from 'react-hot-toast';
import Balance from '../../../../assets/Balance.jsx';
import BankTransfer from './component/BankTransfer';
import UPI from './component/UPI';
import { GetCredentialsApi, GetWalletApi } from '../../../../api/request/wallet/withdraw';
import Paypal from './component/Paypal';
import Crypto from './component/Crypto';
import WithdrawRequest from './WithdrawRequest';
import CashWithdraw from './component/CashWithdraw';
import { GetCurrentCurrencyRateApi, GetPaymentGatewayApi } from '../../../../api/request/wallet/cashdeposit';
import { DownOutlined } from '@ant-design/icons';
import { GetTermsByTermsApi } from '../../../../api/request/common';
import { handleApiError } from '../../../../utils/handleApiError';
import Cregis from './component/Cregis.jsx';
import Match2Pay from './component/Match2Pay.jsx';
import UniPayment from './component/UniPayment.jsx';
import MyFootoorah from './component/MyFootoorah.jsx';
import ChargeSummary from '../../../../components/wallet/ChargeSummary.jsx';
import { GetMyTransactionChargesApi } from '../../../../api/request/wallet/deposit.js';
import { effectiveChargePercent, chargePercentForGateway } from '../../../../utils/clientTransactionCharge.js';


const WithdrawMobile = ({ setPaymentMethod, paymentMethod }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state?.user);
    const [walletDetails, setWalletDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [amount, setAmount] = useState(0);
    const [step, setStep] = useState(1);
    const [isRefresh, setIsRefresh] = useState(false);
    const [credentials, setCredentials] = useState([]);
    const [currencyRate, setCurrencyRate] = useState(null);
    const [tncFileUrl, setTncFileUrl] = useState('');
    const [paymentGateways, setPaymentGateways] = useState([]);
    const [validation, setValidation] = useState('');
    const [pspCharges, setPspCharges] = useState([]);
    const [paymentGatewaysMethods, setPaymentGatewaysMethods] = useState([]);
    // API call to fetch payment gateways for withdrawal
    const getPaymentGateways = async () => {
        try {
            const { data } = await GetPaymentGatewayApi(2);
            if (data?.success) {
                const formattedGateways = data?.data?.map(gateway => ({
                    id: gateway.id,
                    name: gateway.name,
                    value: gateway.id,
                    fees: gateway.fees || 0,
                    processingTime: gateway.processingTime || "24 H",
                    paymentLogoUrl: gateway.paymentLogoUrl,
                    minAmount: gateway.minAmount,
                    maxAmount: gateway.maxAmount,
                    currency: gateway.currency,
                    type: gateway.type
                }));
                setPaymentGateways(formattedGateways);
                setPaymentMethod(formattedGateways[0].name);
                const methods = [];

                for (let i = 0; i < formattedGateways.length; i++) {
                    const gateway = formattedGateways[i];
                    switch (gateway.name) {
                        case "Cregis":
                            methods.push(
                                { label: 'USDT_TRC20', methodValue: 0, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/Crypto.png" },
                                { label: 'USDT_BEP20', methodValue: 1, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/BEP_Logo.jpg" },
                                { label: 'USDT_ERC20', methodValue: 2, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/ERC_20.jpg" },
                            );
                            break;

                        case "Unipayment":
                            methods.push(
                                { label: 'Card Payment', methodValue: 4, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/stripe.png" }
                            );
                            break;

                        case "MyFatoorah":
                            methods.push(
                                { label: 'MyFatoorah', methodValue: 6, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/MyFatoorah.jpeg" }
                            );
                            break;

                        case "Match2Pay":
                            methods.push(
                                { label: 'USDT_ERC20', methodValue: 5, ...gateway, paymentLogoUrl: "https://crm.upforex.live/LogoImage/ERC_20.jpg" }
                            );
                            break;

                        default:
                            methods.push({ label: gateway.name, methodValue: gateway.value || gateway.id, ...gateway, })
                            break;
                    }
                }

                // Optional: Remove duplicate methods
                const uniqueMethods = methods.filter(
                    (m, i, a) => a.findIndex(x => x.methodValue === m.methodValue) === i
                );
                setPaymentMethod(uniqueMethods[0]?.methodValue || null);
                setPaymentGatewaysMethods(uniqueMethods);
            }
        } catch (error) {
            if (error?.response?.data?.error?.message) {
                handleApiError(error);
            } else {
                toast.error('Failed to load withdrawal methods');
            }
        }
    };

    const getWalletDetails = async () => {
        setIsLoading(true);
        try {
            const params = { RuleType: 'Withdraw' }
            const { data } = await GetWalletApi(userDetails?._id, new URLSearchParams(params).toString());
            if (data?.success) setWalletDetails(data?.data)
        } catch (error) {
            setIsLoading(false);
        }
    }

    // const getCredentials = async () => {
    //     try {
    //         const { data } = await GetCredentialsApi();
    //         if (data?.success) {
    //             setCredentials(data?.data);
    //         }
    //     } catch (error) { }
    // }
    const getCurrentCurrencyRate = async () => {
        try {
            const { data } = await GetCurrentCurrencyRateApi();
            if (data?.success) setCurrencyRate(data?.data);
        } catch (error) {
        }
    }
    // const fetchTncFileUrl = async () => {
    //     try {
    //         const { data } = await GetTermsByTermsApi(2);
    //         if (data?.success && data?.data?.fileURL) {
    //             setTncFileUrl(data.data.fileURL);
    //         }
    //     } catch (err) { }
    // }

    useEffect(() => {
        getWalletDetails();
        // getCredentials();
        getCurrentCurrencyRate();
        // fetchTncFileUrl();
        getPaymentGateways();
        const loadCharges = async () => {
            try {
                const { data } = await GetMyTransactionChargesApi();
                if (data?.success) setPspCharges(data?.data?.charges ?? []);
            } catch (error) {
            }
        };
        loadCharges();
    }, []);

    // default select first payment gateway option when paymentGateways are loaded
    useEffect(() => {
        if ((!paymentMethod && paymentMethod !== 0) && paymentGatewaysMethods && paymentGatewaysMethods.length > 0) {
            setPaymentMethod(paymentGatewaysMethods[0].methodValue);
        }
    }, [paymentGatewaysMethods, paymentMethod]);


    const validateAmount = (_, value) => {
        const numericValue = parseFloat(value);
        const min = parseFloat(paymentMethod?.minAmount?.replace(/[^0-9.]/g, ""));
        const max = parseFloat(paymentMethod?.maxAmount?.replace(/[^0-9.]/g, ""));

        if (!value) {
            setValidation('Please deposit enter amount');
            return Promise.reject("Please enter deposit amount");
        }
        if (isNaN(numericValue)) {
            setValidation('Please enter valid number');
            return Promise.reject("Please enter valid number");
        }
        if (numericValue < min) {
            setValidation(`Minimum withdrawal is ${paymentMethod.minAmount}`);
            return Promise.reject(`Minimum withdrawal is ${paymentMethod.minAmount}`);
        }
        if (numericValue > max) {
            setValidation(`Maximum withdrawal is ${paymentMethod.maxAmount}`);
            return Promise.reject(`Maximum withdrawal is ${paymentMethod.maxAmount}`);
        }
        setValidation('');
        return Promise.resolve();
    }

    // const validateAmount = (_, value) => {
    //     if (!value) {
    //         setStep(1);
    //         return Promise.reject(new Error('Please enter amount.'));
    //     }

    //     if (Number(value) <= 0) {
    //         setStep(1);
    //         return Promise.reject(new Error('Please enter a valid amount.'));
    //     }

    //     if (walletDetails?.isRuleActive) {
    //         if (amount < walletDetails?.minAmount) {
    //             setStep(1);
    //             return Promise.reject(new Error(`Amount must be at least $${walletDetails?.minAmount}.`));
    //         }
    //         if (amount > walletDetails?.maxAmount) {
    //             setStep(1);
    //             return Promise.reject(new Error(`Amount cannot exceed $${walletDetails?.maxAmount}.`));
    //         }
    //     }

    //     return Promise.resolve();
    // };

    const handleSubmit = (values) => {
        if (values?.amount && values?.paymentMethod) setStep(2);
    }

    const resetAll = () => {
        form.resetFields();
        setAmount(0);
        setPaymentMethod(null);
        setStep(1);
        setIsRefresh(true);
    }
    const selectedGatewayForFee = paymentGatewaysMethods.find(gateway => gateway.methodValue === paymentMethod);
    const withdrawalPercent = effectiveChargePercent(chargePercentForGateway(pspCharges, selectedGatewayForFee?.id), selectedGatewayForFee?.fees);

    const renderStep = () => {
        const selectedGateway = selectedGatewayForFee;
        switch (selectedGateway?.name) {
            case "Wire Transfer":
                return <BankTransfer amount={amount} paymentGatewayId={selectedGateway?.id} resetAll={resetAll} details={credentials?.bankDetails} tncFileUrl={tncFileUrl} validateAmount={validation} />;
            case "UPI":
                return <UPI amount={amount} resetAll={resetAll} tncFileUrl={tncFileUrl} validateAmount={validation} />;
            case "Paypal":
                return <Paypal amount={amount} resetAll={resetAll} tncFileUrl={tncFileUrl} validateAmount={validation} />;
            case "Crypto":
                return <Crypto amount={amount} resetAll={resetAll} tncFileUrl={tncFileUrl} validateAmount={validation} />;
            case "Cash":
                return <CashWithdraw amount={amount} paymentGatewayId={selectedGateway?.id} resetAll={resetAll} details={credentials?.mobileNumbers} tncFileUrl={tncFileUrl} validateAmount={validation} />;
            case "Match2Pay":
                return <Match2Pay amount={amount} resetAll={resetAll} paymentGatewayId={selectedGateway?.id} validateAmount={validation} />;
            case "Cregis":
                return <Cregis amount={amount} resetAll={resetAll} paymentGatewayId={selectedGateway?.id} methodValue={selectedGateway?.methodValue} validateAmount={validation} />;
            case "Unipayment":
                return <UniPayment amount={amount} resetAll={resetAll} paymentGatewayId={selectedGateway?.id} validateAmount={validation} />;
            case "MyFatoorah":
                return <MyFootoorah amount={amount} resetAll={resetAll} paymentGatewayId={selectedGateway?.id} validateAmount={validation} />;
            default:
                return null;
        }
    }

    return (
        <div className='space-y-5'>

            <div className="mb-4">
                <div className="relative">
                    <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                        <Select
                            value={paymentMethod}
                            onChange={setPaymentMethod}
                            className="w-full !bg-white rounded-xl"
                            size="large"
                            suffixIcon={<div className="flex items-center justify-center h-full w-full"><DownOutlined className="text-gray-400 bg-[#F5F9FD] p-2.5 rounded-lg" /></div>}
                            placeholder="Select Withdrawal Method"
                            popupClassName="custom-select-dropdown"
                            dropdownAlign={{ offset: [0, 0] }}
                            dropdownStyle={{
                                borderRadius: '16px',
                                padding: '8px',
                                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
                                border: 'none',
                                marginTop: '-10px'
                            }}
                        >
                            {paymentGatewaysMethods.map(item => (
                                <Select.Option
                                    key={item?.methodValue}
                                    value={item?.methodValue}
                                    label={<span className="primary font-semibold text-sm">{item?.label}</span>}
                                >
                                    <div className="flex items-center gap-2 py-1 px-2 rounded-lg">
                                        <img
                                            src={item?.paymentLogoUrl}
                                            alt="Icon"
                                            className="h-[30px] w-[30px] object-contain"
                                        />
                                        <span className={`font-semibold text-sm`}>
                                            {item?.label}
                                        </span>

                                    </div>
                                </Select.Option>
                            ))}
                        </Select>

                        {!["Unipayment", "MyFatoorah"].includes(paymentGatewaysMethods.find(g => g.methodValue === paymentMethod)?.name) && (
                            <>
                                <div className="mb-4">
                                    <label className="text-lg font-medium text-gray-700 block mb-2">Withdrawing From</label>
                                    <div className="flex items-center gap-3 py-2 px-4 bg-gray-50 rounded-lg border">
                                        <Balance color="var(--sidebarColor)" className="size-6" />
                                        <div className="flex items-center">
                                            <span className="text-base font-medium">Wallet</span>
                                            <span className="text-sm text-gray-500 ms-2">${walletDetails?.walletAmount || 0}</span>
                                        </div>
                                    </div>
                                </div>

                                <Form.Item
                                    name='amount'
                                    label={<span className="text-lg text-gray-500 font-medium">Withdrawal Amount</span>}
                                    rules={[{ validator: validateAmount }]}
                                >
                                    <Input type='number' prefix="$" placeholder="Amount in USD" size='large' onChange={(e) => setAmount(e?.target?.value)} className='!py-3' />
                                </Form.Item>
                                <div className="mt-4">
                                    <ChargeSummary amount={amount} percent={withdrawalPercent} mode="withdraw" />
                                </div>
                            </>
                        )}
                    </Form>
                </div>
            </div>

            {renderStep()}

            <WithdrawRequest isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
        </div>
    )
}

export default WithdrawMobile